// extracted by mini-css-extract-plugin
export default {"delete_btn":"styles_delete_btn__hHa-Z","cancel_btn":"styles_cancel_btn__Y94Sh","content_container":"styles_content_container__ydfQE","text":"styles_text__+A0tk"};